<!-- ===== Header ===== -->
<div mat-dialog-title class="dlg-h">
  <div class="t">
    <h2>{{ activeSubscription['solution_name'] }}</h2>
    <span class="vbadge">{{ activeSubscription['version_name'] }}</span>
  </div>
  <div class="progress" *ngIf="totalQuestions > 0">
    <div class="pn">
      <span class="n">{{ answeredQuestions }} / {{ totalQuestions }}</span>
      <span class="l">answered</span>
    </div>
    <div class="pbar">
      <i [style.width.%]="progressPct"></i>
    </div>
  </div>
  <button class="btn-ghost" [disabled]="preview" (click)="resetForm()">
    Reset
  </button>
</div>

<!-- ===== Body ===== -->
<div class="dlg-b" mat-dialog-content>
  <div class="pv-banner" *ngIf="preview">
    <mat-icon>visibility</mat-icon>
    Preview — this is the form your customers fill in. Saving is disabled.
  </div>

  <!-- --------------------------------Step 1 ---------------------->
  <div class="csect">
    <div class="csect-h">
      <span class="ic">▦</span>
      <div>
        <h3>Connect your data sources</h3>
        <div class="hint">Map each dataset this version needs</div>
      </div>
      <span
        class="stpill"
        *ngIf="usedDatasetsInVersion?.length"
        [class.done]="connectedDatasets === usedDatasetsInVersion.length"
        [class.todo]="connectedDatasets < usedDatasetsInVersion.length"
      >{{ connectedDatasets }} of {{ usedDatasetsInVersion.length }} connected</span
      >
    </div>
    <div class="csect-b">
      <div class="chip-wrap" *ngIf="usedDatasetsInVersion">
        <button
          mat-dialog-close
          type="button"
          class="connect-chip"
          [class.done]="getMappingValues(data['data_name']) != null"
          [disabled]="preview"
          [routerLink]="
            data?.source_id__connection_type_id == 'Files_Upload_(xlsx)'
              ? 'home/data_management/upload_files/' + data?.data_name
              : '/home/data_management/data_configuration/data_pull/' +
                data?.data_name
          "
          (click)="setDataset(data)"
          *ngFor="let data of usedDatasetsInVersion"
        >
          <mat-icon *ngIf="getMappingValues(data['data_name']) === null"
          >add
          </mat-icon
          >
          <mat-icon *ngIf="getMappingValues(data['data_name']) != null"
          >done_all
          </mat-icon
          >
          {{ data['data_name'] }}
        </button>
      </div>
    </div>
  </div>

  <!-- -------------------------------------Step 2 ------------------------->
  <div class="csect" *ngIf="groupedStep2">
    <div class="csect-h">
      <span class="ic">⇄</span>
      <div>
        <h3>Map your columns</h3>
        <div class="hint">
          Tell us which columns in your data hold what the pipeline needs
        </div>
      </div>
      <span
        class="stpill"
        [class.done]="step2Answered === step2Total"
        [class.todo]="step2Answered < step2Total"
      >{{ step2Answered }} of {{ step2Total }} done</span
      >
    </div>
    <div class="csect-b">
      <div class="dgroup" *ngFor="let step2 of groupedStep2 | keyvalue">
        <div class="dh">
          <span class="tbl-ic">▦</span>
          Your dataset <code>{{ step2.key | textpretty }}</code>
        </div>
        <div class="cq" *ngFor="let step2config of step2.value; let i = index">
          <span class="ql">
            {{ step2config['question'] }}<span class="req">*</span>
          </span>
          <span>
            <mat-form-field class="field-width">
              <mat-label>Select Column</mat-label>
              <mat-select [(ngModel)]="step2config['mapping']">
                <mat-option
                  *ngFor="
                    let column of getMappingValues(step2config['datasetname'])
                  "
                  [value]="column"
                >{{ column }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- ------------------------------------Step 3 -------------------------- -->
  <div class="csect" *ngIf="groupedStep3">
    <div class="csect-h">
      <span class="ic">⚙</span>
      <div>
        <h3>Run settings</h3>
        <div class="hint">These values are used every time the solution runs</div>
      </div>
      <span
        class="stpill"
        [class.done]="step3Answered === step3Total"
        [class.todo]="step3Answered < step3Total"
      >{{ step3Answered }} of {{ step3Total }} done</span
      >
    </div>
    <div class="csect-b">
      <div *ngFor="let step3 of groupedStep3; let i = index" class="cq">
        <span class="ql">{{ step3['prompt'] }}<span class="req">*</span></span>
        <span>
          <!--                  Date field  -->
          <mat-form-field
            *ngIf="step3['fieldType'] === 'date'"
            class="field-width"
          >
            <mat-label>Enter Format</mat-label>
            <input
              type="text"
              matInput
              [formControl]="myControl"
              [(ngModel)]="step3['mapping']"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option['format'] }} &nbsp; &nbsp; eg:{{ option['example'] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!--        For Text      -->
          <mat-form-field
            appearance="fill"
            class="field-width"
            *ngIf="step3['fieldType'] === 'text'"
          >
            <mat-label>Type an answer</mat-label>
            <input
              matInput
              placeholder="Type an answer…"
              [(ngModel)]="step3['mapping']"
            />
          </mat-form-field>

          <!--          For Single Single/Multi-Select    -->
          <mat-form-field
            class="field-width"
            *ngIf="
              step3['fieldType'] === 'single-select-string' ||
              step3['fieldType'] === 'multi-select-string'
            "
          >
            <mat-label>Select Column(s)</mat-label>
            <mat-select
              [multiple]="step3['fieldType'] === 'multi-select-string'"
              [(ngModel)]="step3['mapping']"
            >
              <mat-option
                *ngFor="let data of getMappingValues(step3['dataset'][0])"
                [value]="data"
              >{{ data }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
      </div>
    </div>
  </div>

  <!--  -----------------------------------Step 4 ----------------------------- -->
  <div class="csect" *ngIf="projectToSchedules?.length">
    <div class="csect-h">
      <span class="ic">◷</span>
      <div>
        <h3>Automation</h3>
        <div class="hint">
          Optional — run automatically without visiting this page
        </div>
      </div>
      <span
        class="stpill"
        [class.done]="schedAnswered === schedTotal"
        [class.todo]="schedAnswered < schedTotal"
      >{{ schedAnswered }} of {{ schedTotal }} scheduled</span
      >
    </div>
    <div class="csect-b">
      <div *ngFor="let prj of projectToSchedules; index as i" class="sched-row">
        <div class="sr-q">
          <span>{{ prj?.question }}</span>
        </div>
        <div class="sr-card">
          <div class="sched-card" *ngIf="prj?.scheduleData">
            <div class="sched-title">Scheduled Time</div>
            <div
              class="sched-line"
              *ngFor="
                let item of prj?.scheduleData
                  | keyvalue
                  | excludeKeys : ['id', 'zone']
              "
            >
              <span class="sk">{{ item.key }}</span> :
              {{
                item.key === 'expires'
                  ? (item.value | date : 'dd-MMMM-yyyy')
                  : item.value === '*' ||
                  item.value === null ||
                  item.value.includes('All')
                    ? 'All'
                    : item.value
              }}
            </div>
          </div>
        </div>

        <button (click)="openScheduler(prj)" class="btn-ghost">
          {{ prj?.scheduleData ? 'Reschedule' : 'Schedule' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ===== Footer ===== -->
<mat-dialog-actions class="dlg-f">
  <span class="f-note" *ngIf="!preview"
  >Answers are saved to this subscription and reused on every run.</span
  >
  <span class="f-spacer"></span>
  <button class="btn-ghost" (click)="closeDialogForm()">
    {{ preview ? 'Close' : 'Cancel' }}
  </button>
  <button
    class="btn-primary"
    *ngIf="!preview"
    [disabled]="preview"
    (click)="save()"
  >
    {{ formExist ? 'Update' : 'Save' }}
  </button>
</mat-dialog-actions>
